export interface Product {
  id: number;
  name: string;
  description: string;
  salePrice: number;
  regularPrice: number;
  categories: string[];
  images: string[];
  stock: number;
  inStock: boolean;
  rating: number;
  reviewCount: number;
  isCampaign: boolean;
  isNew: boolean;
  isFeatured: boolean;
  brand: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  slug: string;
  color: string;
}

export const categories: Category[] = [
  { id: 'aerosol', name: 'Aerosol', icon: 'spray', slug: 'aerosol', color: '#E31E24' },
  { id: 'aksesuar-temizlik', name: 'Aksesuar & Temizlik', icon: 'cleaning', slug: 'aksesuar-temizlik', color: '#FF6B00' },
  { id: 'arac-oda-parfumu', name: 'Araç ve Oda Parfümü', icon: 'perfume', slug: 'arac-oda-parfumu', color: '#8B5CF6' },
  { id: 'cam-suyu', name: 'Cam Suyu', icon: 'water', slug: 'cam-suyu', color: '#0EA5E9' },
  { id: 'kislik-urunler', name: 'Kışlık Ürünler', icon: 'winter', slug: 'kislik-urunler', color: '#06B6D4' },
  { id: 'motor-antifrizleri', name: 'Motor Antifrizleri', icon: 'antifreeze', slug: 'motor-antifrizleri', color: '#10B981' },
  { id: 'oto-bakim', name: 'Oto Bakım', icon: 'carmaintenance', slug: 'oto-bakim', color: '#F59E0B' },
  { id: 'professional', name: 'Professional', icon: 'professional', slug: 'professional', color: '#6366F1' },
  { id: 'kendi-setini-olustur', name: 'Kendi Setini Oluştur', icon: 'customset', slug: 'kendi-setini-olustur', color: '#EC4899' },
];

export const products: Product[] = [
  {
    id: 4894,
    name: 'T-RaX Plastik ve Torpido Yenileyici Seramik Kaplama 50ML',
    description: 'Kaçuk, deri, vinil için restorasyon ve koruma kaplamasıdır. Tek uygulamada plastiklerinizi fabrika ayarına geri döndürün.',
    salePrice: 378.5,
    regularPrice: 478.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Plastik-yenileyici-seramik-2-kod-1189-Photoroom.png-Photoroom.png'],
    stock: 99962,
    inStock: true,
    rating: 4.81,
    reviewCount: 40,
    isCampaign: true,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 4895,
    name: 'T-RaX Deri Bakım Kremi 250ML',
    description: 'Aracınızın her türlü deri, vinil ve plastik aksamlarına koruma, bakım sağlar, yumuşatır ve aynı zamanda parlatır.',
    salePrice: 255.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/DERI-BAKIM-KREMI-Photoroom.png'],
    stock: 99998,
    inStock: true,
    rating: 5,
    reviewCount: 1,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4896,
    name: 'T-RaX Döşeme ve Koltuk Temizleyici 500ML',
    description: 'Döşemelerinizi temizler ve korur. Yağ, mürekkep, çikolata ve birçok lekeyi temizler.',
    salePrice: 199.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Doseme-ve-Koltuk-Temizleyici.png'],
    stock: 99987,
    inStock: true,
    rating: 4.77,
    reviewCount: 20,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4898,
    name: 'T-RaX Deri Vinil Protectant Yağı 200ML',
    description: 'Aracınızın her türlü deri, vinil ve plastik aksamlarını parlatır, korur ve yumuşatır.',
    salePrice: 185.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Vinil-Koruyucu.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4916,
    name: 'Hippo Exclusive Quick Ceramic 9H 50ML',
    description: 'Hippo Exclusive Quick Ceramic 9H 50ML',
    salePrice: 255.5,
    regularPrice: 355.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Quick-9H.png'],
    stock: 99995,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: true,
    isFeatured: false,
    brand: 'Hippo',
  },
  {
    id: 4920,
    name: 'T-RaX Seramik Boya Koruyucu Sprey 500ML',
    description: 'Aracınızın dış yüzeylerinde diğer dış etkenlere karşı koruma sağlayan koruyucu bir kaplama sağlar.',
    salePrice: 288.5,
    regularPrice: 399.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/SERAMIK-BOYA-KORUYUCU-Photoroom.png'],
    stock: 99990,
    inStock: true,
    rating: 4.77,
    reviewCount: 41,
    isCampaign: true,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 4921,
    name: 'T-RaX Zift Temizleyici 500ML',
    description: 'Boya üzerinde bulunan yağ, katran ve lekeleri hemen söker.',
    salePrice: 225,
    regularPrice: 325,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ZIFT-Photoroom.png'],
    stock: 99996,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4922,
    name: 'T-RaX Su İtici Cam Seramiği 170ML',
    description: 'Sonbahar ve kış aylarında yağmurlu günlerde aracınızın aynasını ve camlarını kaplayan su taneleri görüşünüzü engeller.',
    salePrice: 105,
    regularPrice: 165,
    categories: ['aksesuar-temizlik', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/SU-ITICI-Photoroom.png'],
    stock: 99997,
    inStock: true,
    rating: 4.79,
    reviewCount: 41,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4924,
    name: 'T-RaX Renkli Cila - Beyaz - 250ML',
    description: 'Silikon içeriği sayesinde koruma ve parlaklık sağlar. Kılcal çizikleri yok eder.',
    salePrice: 159.5,
    regularPrice: 198.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Renkli-Cila-Beyaz.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4925,
    name: 'T-RaX Far Temizleyici 250ML',
    description: 'Farlarınız sararmış ve önünüzü aydınlatmıyorsa, farlarınızı bu ürünle kolayca temizleyebilirsiniz.',
    salePrice: 240.5,
    regularPrice: 265.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Far-Temizleyici.png'],
    stock: 99999,
    inStock: true,
    rating: 4.86,
    reviewCount: 20,
    isCampaign: false,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 4926,
    name: 'T-RaX Boya Koruma 250ML',
    description: 'Her renk araca uumludur. Aracınızın boyasına güçlü bir bakım yapar.',
    salePrice: 255.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/BOYA-KORUMA-Photoroom.png'],
    stock: 99997,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4932,
    name: 'T-RaX Cam Buz Çözücü 500ML',
    description: 'Kışın camlarda veya kapı kilitlerindeki don olaylarını engellemek için yapılmış bir üründür.',
    salePrice: 0,
    regularPrice: 170,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Buz-Cozucu.png'],
    stock: 99996,
    inStock: true,
    rating: 5,
    reviewCount: 19,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4933,
    name: 'T-RaX Cam Temizleyici 500ML',
    description: 'Cam yüzeyinde oluşan böcek, sinek pisliklerini ve diğer kirleri temizler.',
    salePrice: 85,
    regularPrice: 125,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/CAMSIL-Photoroom.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4947,
    name: 'T-RaX Lastik Süngeri - Poşetli',
    description: 'T-RaX Sihirli Silgi Sünger',
    salePrice: 67,
    regularPrice: 99,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Lastik-Sungeri.png'],
    stock: 99991,
    inStock: true,
    rating: 4.8,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4949,
    name: 'T-RaX Pasta Cila Carnauba Kavanoz 250ML',
    description: 'Özel formülü sayesinde koruma ve parlaklık sağlar. Etkisini kaybetmez 2-3 yıkama boyunca.',
    salePrice: 265.5,
    regularPrice: 377.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/13.png'],
    stock: 100000,
    inStock: true,
    rating: 4.75,
    reviewCount: 40,
    isCampaign: true,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 4951,
    name: 'T-RaX Çizik Alıcı Carnauba Kavanoz 250ML',
    description: 'Özel formülü sayesinde kılcal çizikleri yok eder, koruma ve parlaklık sağlar.',
    salePrice: 265.5,
    regularPrice: 377.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Carnauba-Cizik-Alici.png'],
    stock: 99999,
    inStock: true,
    rating: 4.55,
    reviewCount: 40,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4953,
    name: 'T-RaX Saf Su 500ML',
    description: 'Temas ettiği metallerin oksitlenmesini engeler. Deiyonize su.',
    salePrice: 0,
    regularPrice: 75,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Saf-Su.png'],
    stock: 99980,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4970,
    name: 'T-RaX Lastik ve Tampon Parlatıcı 500ML',
    description: 'Aracınızda lastik, tampon, pas pas, kapı içi fitilleri ve diğer tüm plastik parçalarda kullanabilirsiniz.',
    salePrice: 199.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/LASTIK-PARLATICI-Photoroom.png'],
    stock: 99992,
    inStock: true,
    rating: 4.79,
    reviewCount: 41,
    isCampaign: true,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 4971,
    name: 'T-RaX Lastik ve Tampon Cila Seti 200ML',
    description: 'Lastikleriniz, plastik aksamlar ve deri yüzeyler için özel olarak formüle edilmiş bir bakım ürünüdür.',
    salePrice: 210.5,
    regularPrice: 295.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/2IN1-Parlatici.png'],
    stock: 99970,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 4980,
    name: 'T-RaX Long Life Kırmızı Antifreeze -37 3LT',
    description: 'T-RAX LONG LIFE KIRMIZI ANTIFREEZE -37 3LT',
    salePrice: 0,
    regularPrice: 625,
    categories: ['kislik-urunler', 'motor-antifrizleri', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Long-Life-Antifreeze.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5003,
    name: 'T-RaX Mikrofiber Yıkama ve Pasta Eldiveni',
    description: 'T-RAX MİKROFİBER YIKAMA VE PASTA ELDİVENİ',
    salePrice: 138,
    regularPrice: 235,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Mikrofiber-Yikama-Eldiveni.png'],
    stock: 99994,
    inStock: true,
    rating: 5,
    reviewCount: 40,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5007,
    name: 'T-RaX Konsantre Yazlık Cam Suyu Şampuanı 50ML',
    description: 'Sileceklerinizi yumuşatır, silecekleriniz sertleşmez ve ömrü uzar.',
    salePrice: 75,
    regularPrice: 125,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Konsantre-Cam-Suyu-Sampuani.png'],
    stock: 99997,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5020,
    name: 'T-RaX Super Mavi Antifiriz -37 Derece 3LT',
    description: 'T-RaX Super mavi antifiriz -37 derece 3lt',
    salePrice: 0,
    regularPrice: 485,
    categories: ['kislik-urunler', 'motor-antifrizleri', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Super-Antifreeze-3LT.png'],
    stock: 99998,
    inStock: true,
    rating: 5,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5021,
    name: 'T-RaX Super Mavi Antifiriz -37 Derece 1LT',
    description: 'T-RaX Super mavi antifiriz -37 derece 1lt',
    salePrice: 165,
    regularPrice: 225,
    categories: ['kislik-urunler', 'motor-antifrizleri', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Super-Antifreeze-1LT.png'],
    stock: 100000,
    inStock: true,
    rating: 4.67,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5023,
    name: 'T-RaX Buğu Önleyici 500ML',
    description: 'Otomobil, ev ve gözlük camlarında oluşan buğuları önlemek için kullanılan üstün formüllü bir üründür.',
    salePrice: 99,
    regularPrice: 145,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/BUGU-ONLEYICISI-Photoroom.png'],
    stock: 100000,
    inStock: true,
    rating: 4.94,
    reviewCount: 41,
    isCampaign: false,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 5028,
    name: 'T-RaX Buz Kazıyıcı',
    description: 'T-RaX Buz kazıyıcı',
    salePrice: 69,
    regularPrice: 85,
    categories: ['aksesuar-temizlik', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/borulss.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5029,
    name: 'T-RaX Ayna Asmalı 8 ML - Bubblegum',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Bubblegum.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5031,
    name: 'T-RaX Ayna Asmalı 8 ML - Okyanus',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Okyanus.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5033,
    name: 'T-RaX Ayna Asmalı 8 ML - Vanilya',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Vanilya.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5034,
    name: 'T-RaX Ayna Asmalı 8 ML - Odunsu',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 215,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Odunsu.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5038,
    name: 'T-RaX Ayna Asmalı 8 ML - Kavun',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 215,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Kavun.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5040,
    name: 'T-RaX Ayna Asmalı 8ML - Special Million',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 215,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Special.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5042,
    name: 'T-RaX Ayna Asmalı 8 ML - Lavanta',
    description: 'Aromalı dekoratif araç kokuları kötü kokuları giderir ve hoş bir koku sağlar.',
    salePrice: 135,
    regularPrice: 215,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Lavanta.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5044,
    name: 'T-RaX Sprey Oto Koku 170ML - Bubblegum',
    description: 'Araç içinde ve uygulayacağınız her ortamın kötü kokularını giderir.',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Oto-Parfumu-Bubblegum.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5045,
    name: 'T-RaX Sprey Oto Koku 170ML - Okyanus',
    description: 'Araç içinde ve uygulayacağınız her ortamın kötü kokularını giderir.',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Oto-Parfumu-Okyanus.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5046,
    name: 'T-RaX Sprey Oto Koku 170ML - Vanilya',
    description: 'Araç içinde ve uygulayacağınız her ortamın kötü kokularını giderir.',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/dfsdz1.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5123,
    name: 'T-RaX Akü Takviye Kablosu 600 Amper',
    description: 'T-RaX Takviye Kablosu 600 amper',
    salePrice: 430,
    regularPrice: 520,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/aku-takviye-600.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: true,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5124,
    name: 'T-RaX Akü Takviye Kablosu 1000 Amper',
    description: 'T-RaX Takviye Kablosu 1000 amper',
    salePrice: 499,
    regularPrice: 600,
    categories: ['aksesuar-temizlik', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Aku-Takviye-Kablosu-1000.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: true,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5128,
    name: 'T-RaX Mikrofiber Bez Nano Teknoloji 50x70',
    description: 'Nano Teknoloji',
    salePrice: 135,
    regularPrice: 220,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Bez-50x70-1.png'],
    stock: 99990,
    inStock: true,
    rating: 5,
    reviewCount: 40,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5132,
    name: 'T-RaX Oto Yıkama Süngeri Büyük Boy',
    description: 'Aracınızı cilalı oto şampuanla yıkadıktan sonra çiziklerden korumak için sünger ile uygulama yapabilirsiniz.',
    salePrice: 78,
    regularPrice: 99,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Oto-Temizlik-Sungeri.png'],
    stock: 99989,
    inStock: true,
    rating: 4.9,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5134,
    name: 'T-RaX Oto Cilalı Şampuan Portakal Kokulu 500ML',
    description: 'Bol köpüklü cilalı araç şampuanı. Temizleme ve cilalama işlemini birlikte yapar.',
    salePrice: 120,
    regularPrice: 165,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cilali-Oto-Sampuan-Portakal-500ML.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5136,
    name: 'T-RaX Oto Cilalı Şampuan Elma Kokulu 500ML',
    description: 'Bol köpüklü cilalı araç şampuanı. Temizleme ve cilalama işlemini birlikte yapar.',
    salePrice: 120,
    regularPrice: 165,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cilali-Oto-Sampuan-Elma-500ML.png'],
    stock: 99998,
    inStock: true,
    rating: 4.75,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5139,
    name: 'T-RaX Demir Tozu Temizleyici 500ML',
    description: 'Araç jantlarını ve dış metal aksamlarda gözükmeyen demir tozlarını temizlemek için üretilen üstün formüllü bir üründür.',
    salePrice: 288.5,
    regularPrice: 399.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Demiz-Tozu-Temizleyici.png'],
    stock: 99967,
    inStock: true,
    rating: 4.69,
    reviewCount: 41,
    isCampaign: true,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 5140,
    name: 'T-RaX Jant Temizleyici 500ML',
    description: 'Araç jantlarınızı parlatmak için üretilen üstün kalite bir üründür.',
    salePrice: 199.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Jant-Temizleyici.png'],
    stock: 99998,
    inStock: true,
    rating: 5,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5143,
    name: 'T-RaX Motor Temizleyici 500ML',
    description: 'Aracın motor kısmına ürünü çalkalayıp sprey kısmıyle püskürtün.',
    salePrice: 198.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/TRAX-MOTOR-1.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5156,
    name: 'T-RAX Balata Sprey 500ML',
    description: 'T-RAX Balata Sprey 500ML',
    salePrice: 232.5,
    regularPrice: 300,
    categories: ['aerosol', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/BALATA-Photoroom.png'],
    stock: 99994,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5168,
    name: 'T-RaX Klima Bombası Special Million 150ML',
    description: 'Araç içi ve klima sisteminden yayılan birikmiş küf, bakteri ve sigara kokularına karşı etkilidir.',
    salePrice: 288.5,
    regularPrice: 425.5,
    categories: ['aerosol', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/9-1.png'],
    stock: 99995,
    inStock: true,
    rating: 5,
    reviewCount: 40,
    isCampaign: true,
    isNew: true,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 5169,
    name: 'T-RaX Konsantre Lastik ve Tampon Parlatıcı 3LT',
    description: 'T-RaX Konsantre Lastik ve Tampon Parlatıcı 3LT',
    salePrice: 558.5,
    regularPrice: 695.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Lastik-ve-Tampon-Parlatici.png'],
    stock: 99983,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5174,
    name: 'T-RaX Konsantre Motor Temizleyici 3LT',
    description: 'T-RaX Konsantre Motor Temizleyici 3LT',
    salePrice: 358.5,
    regularPrice: 410.5,
    categories: ['oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Motor-Temizleyici-1.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5182,
    name: 'T-RaX Konsantre Demir Tozu Temizleyici 3LT',
    description: 'T-RaX Konsantre Demir Tozu Temizleyici 3LT',
    salePrice: 675,
    regularPrice: 950,
    categories: ['aksesuar-temizlik', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Demir-Tozu-Temizleyici.png'],
    stock: 1,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5620,
    name: 'T-RaX Torpido Bakım Sütü 500ML',
    description: 'Araçların torpido aksamları ve deri yüzeyler için özel formüle edilmiş bakım ürünüdür.',
    salePrice: 199.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Torpido-Bakim-Sutu.png'],
    stock: 99986,
    inStock: true,
    rating: 4.93,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: true,
    brand: 'T-RaX',
  },
  {
    id: 5623,
    name: 'T-RaX Hızlı Cila 500ML',
    description: 'Silikon içeriği sayesinde koruma ve parlaklık sağlar. Etkisini 2 veya 3 yıkama boyunca kaybetmez.',
    salePrice: 199.5,
    regularPrice: 285.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Hizli-Cila.png'],
    stock: 99987,
    inStock: true,
    rating: 4.81,
    reviewCount: 40,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6087,
    name: 'T-RaX Yazlık Cam Suyu 0/50 Derece 2.5LT',
    description: 'T-RaX Yazlık Cam Suyu 0/50 Derece 2.5LT',
    salePrice: 0,
    regularPrice: 0,
    categories: ['cam-suyu', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifrizi-2.5LT.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: true,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6091,
    name: 'T-RaX Kışlık Cam Suyu 30 Derece 5LT',
    description: 'T-RaX Kışlık Cam Suyu 30 Derece 5LT',
    salePrice: 226.85,
    regularPrice: 299,
    categories: ['cam-suyu', 'kislik-urunler', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifrizi.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6093,
    name: 'T-RaX Kışlık Cam Suyu 30 Derece 2.5LT',
    description: 'T-RaX Kışlık Cam Suyu 30 Derece 2.5LT',
    salePrice: 180.85,
    regularPrice: 199.99,
    categories: ['cam-suyu', 'kislik-urunler', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifirizi-2.5LT.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6101,
    name: 'T-RaX Kışlık Konsantre Cam Suyu 96.8 Derece',
    description: 'Kullanım alanları: Cam suyu haznesindeki suyun donmasını önler.',
    salePrice: 0,
    regularPrice: 0,
    categories: ['cam-suyu', 'aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Kislik-Konsantre-Cam-Suyu-Antifirizi.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5158,
    name: 'T-RaX Parfume Auto Silicone - Woody',
    description: 'Otonuzda deri, torpido, iç döşeme, bakalit gibi parlatınız yüzeyler için.',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aerosol', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/woody.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5159,
    name: 'T-RaX Parfume Auto Silicone - Lemon',
    description: 'Otonuzda deri, torpido, iç döşeme, bakalit gibi parlatınız yüzeyler için.',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aerosol', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/lemon.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5160,
    name: 'T-RaX Parfume Auto Silicone - New Car',
    description: 'Otonuzda deri, torpido, iç döşeme, bakalit gibi parlatınız yüzeyler için.',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aerosol', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/new-car.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5118,
    name: 'T-RaX Benzin Bidonu 5LT',
    description: 'Kolay tutuşur. Benzin doldurmak içindir.',
    salePrice: 85,
    regularPrice: 99,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Benzin-Bidonu.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5120,
    name: 'T-RaX Kokusuz Çakmaklıklı Küllük',
    description: 'Etiket üzerindeki slogan: At içine sigaran sünsün.',
    salePrice: 69,
    regularPrice: 85,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/kulluk-Photoroom.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5153,
    name: 'T-RaX Limon Kolonyası Sprey 150ML',
    description: 'T-RaX Limon Kolonyası Sprey 150ML',
    salePrice: 77.5,
    regularPrice: 99,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Limon-Kolonyasi-150ML.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5155,
    name: 'T-RaX Limon Kolonyası Sprey 400ML',
    description: 'T-RaX Limon kolonyası Sprey 400ML',
    salePrice: 125,
    regularPrice: 145,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Limon-Kolonyasi-Buyuk.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5142,
    name: 'T-RaX 4EX Leke Çıkarıcı 1LT Genel Temizlik',
    description: 'Ürünümüz nerelerde kullanılır: Oto detay temizliği, ev temizliği, bulaşık ve çamaşır makinelerinde.',
    salePrice: 210.5,
    regularPrice: 299.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/4eexx-Photoroom.png'],
    stock: 99996,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5043,
    name: 'T-RaX Ayna Asmalı 8 ML - Kestane',
    description: 'T-RaX Ayna Asmalı 8 ML - Kestane',
    salePrice: 135,
    regularPrice: 215,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-19_50_30.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5048,
    name: 'T-RaX Sprey Oto Koku 170ML - Odunsu',
    description: 'T-RaX Sprey Oto Koku 170ML - Odunsu',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-20_24_38.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5050,
    name: 'T-RaX Sprey Oto Koku 170ML - Sun Cream Dream',
    description: 'T-RaX Sprey Oto Koku 170ML - Sun Cream Dream',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-20_12_50.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5053,
    name: 'T-RaX Sprey Oto Koku 170ML - Kavun',
    description: 'T-RaX Sprey Oto Koku 170ML - Kavun',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-20_30_40.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5054,
    name: 'T-RaX Sprey Oto Koku 170ML - Special Million',
    description: 'T-RaX Sprey Oto Koku 170ML - Special Million',
    salePrice: 145,
    regularPrice: 225,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-20_10_00.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5055,
    name: 'T-RaX Sprey Oto Koku 170ML - Kestane',
    description: 'T-RaX Sprey Oto Koku 170ML - Kestane',
    salePrice: 145,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-20_26_40.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5079,
    name: 'T-RaX Sprey oto Koku 500ML Bubblegum',
    description: 'T-RaX Sprey oto Koku 500ML Bubblegum',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_50_19.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5080,
    name: 'T-RaX Sprey oto Koku 500ML Okyanus',
    description: 'T-RaX Sprey oto Koku 500ML Okyanus',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_15_47.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5081,
    name: 'T-RaX Sprey oto Koku 500ML Vanilya',
    description: 'T-RaX Sprey oto Koku 500ML Vanilya',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_20_24.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5082,
    name: 'T-RaX Sprey oto Koku 500ML Odunsu',
    description: 'T-RaX Sprey oto Koku 500ML Odunsu',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_10_47.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5083,
    name: 'T-RaX Sprey oto Koku 500ML Sun Cream Dream',
    description: 'T-RaX Sprey oto Koku 500ML Sun Cream Dream',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_22_46.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5084,
    name: 'T-RaX Sprey oto Koku 500ML Kavun',
    description: 'T-RaX Sprey oto Koku 500ML Kavun',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_08_19.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5085,
    name: 'T-RaX Sprey Oto Koku 500ML - Special Million',
    description: 'T-RaX Sprey Oto Koku 500ML - Special Million',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_53_59.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5087,
    name: 'T-RaX Sprey Oto Koku 500ML Kestane',
    description: 'T-RaX Sprey Oto Koku 500ML Kestane',
    salePrice: 189,
    regularPrice: 285.5,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-18_13_32.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5116,
    name: 'T-RaX Cam Buz Kazıyıcı',
    description: 'T-RaX Cam Buz Kazıyıcı',
    salePrice: 0,
    regularPrice: 0,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/32.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5129,
    name: 'T-RaX Mikrofiber Bez Nano Teknoloji 40x40',
    description: 'T-RaX Mikrofiber Bez Nano Teknoloji 40x40',
    salePrice: 113,
    regularPrice: 175,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Bez-40x40-1.png'],
    stock: 99988,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5130,
    name: 'T-RaX Mikrofiber Bez Nano Teknoloji 4’lü Eko',
    description: 'T-RaX Mikrofiber Bez Nano Teknoloji 4’lü Eko',
    salePrice: 113,
    regularPrice: 175,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-22_46_28.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5138,
    name: 'T-RaX Oto Cilalı Şampuan Portakal Kokulu 1LT',
    description: 'T-RaX Oto Cilalı Şampuan Portakal Kokulu 1LT',
    salePrice: 199,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.05.jpeg'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5157,
    name: 'Wo40 Pas Sökücü 200ML',
    description: 'Wo40 Pas Sökücü 200ML',
    salePrice: 232.5,
    regularPrice: 300,
    categories: ['aksesuar-temizlik', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/64.png'],
    stock: 99997,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5162,
    name: 'T-RaX Parfume Auto Silicone - Tobacco',
    description: 'T-RaX Parfume Auto Silicone - Tobacco',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-19_27_15.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5165,
    name: 'T-RaX Parfume Auto Silicone - Strawberry',
    description: 'T-RaX Parfume Auto Silicone - Strawberry',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-19_25_14.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5167,
    name: 'T-RaX Parfume Auto Silicone - Special Million',
    description: 'T-RaX Parfume Auto Silicone - Special Million',
    salePrice: 226.5,
    regularPrice: 265.5,
    categories: ['aksesuar-temizlik', 'arac-oda-parfumu', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-19_23_49.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5171,
    name: 'T-RaX Konsantre Torpido Bakım Sütü 3LT',
    description: 'T-RaX Konsantre Torpido Bakım Sütü 3LT',
    salePrice: 558.5,
    regularPrice: 695.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-21_49_04-1.png'],
    stock: 99979,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5172,
    name: 'T-RaX Konsantre Jant Temizleyici 3LT',
    description: 'T-RaX Konsantre Jant Temizleyici 3LT',
    salePrice: 398.5,
    regularPrice: 455.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-22_15_33.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5176,
    name: 'T-RaX Konsantre Döşeme ve Koltuk Temizleyici 3LT',
    description: 'T-RaX Konsantre Döşeme ve Koltuk Temizleyici 3LT',
    salePrice: 358.5,
    regularPrice: 410.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-22_24_33.png'],
    stock: 2,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5178,
    name: 'T-RaX Konsantre 4 Ex Leke Çıkarıcı 3LT Genel Temizlik',
    description: 'T-RaX Konsantre 4 Ex Leke Çıkarıcı 3LT Genel Temizlik',
    salePrice: 398.5,
    regularPrice: 460.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-22_02_42.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5180,
    name: 'T-RaX Konsantre Hızlı Cila 3LT',
    description: 'T-RaX Konsantre Hızlı Cila 3LT',
    salePrice: 399,
    regularPrice: 450,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-21_56_16.png'],
    stock: 99978,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5184,
    name: 'T-RaX Konsantre Fırçasız Oto Köpük 3LT',
    description: 'T-RaX Konsantre Fırçasız Oto Köpük 3LT',
    salePrice: 339.8,
    regularPrice: 400,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-22_11_10.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5627,
    name: 'T-RaX Sıvı Pasta Cila 250ML',
    description: 'T-RaX Sıvı Pasta Cila 250ML',
    salePrice: 195,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-21_33_16.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 5630,
    name: 'T-RaX Sıvı Çizik Alıcı 250ML',
    description: 'T-RaX Sıvı Çizik Alıcı 250ML',
    salePrice: 195.5,
    regularPrice: 225.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-19_30_35.png'],
    stock: 99992,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6067,
    name: 'T-RaX Süt Silikon Sünger Set 250ML',
    description: 'T-RaX Süt Silikon Sünger Set 250ML',
    salePrice: 210.5,
    regularPrice: 295.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.05-3.jpeg'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6089,
    name: 'T-RaX Yazlık Cam Suyu 0/50 Derece 1LT',
    description: 'T-RaX Yazlık Cam Suyu 0/50 Derece 1LT',
    salePrice: 0,
    regularPrice: 0,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifrizi-1LT.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6095,
    name: 'T-RaX Kışlık Cam Suyu 30 Derece 1LT',
    description: 'T-RaX Kışlık Cam Suyu 30 Derece 1LT',
    salePrice: 118.5,
    regularPrice: 155.5,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifirizi-1LT.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6097,
    name: 'Ice&Haze Kışlık Cam Suyu 20 Derece 5LT',
    description: 'Ice&Haze Kışlık Cam Suyu 20 Derece 5LT',
    salePrice: 215.5,
    regularPrice: 255.5,
    categories: ['aksesuar-temizlik', 'cam-suyu', 'kislik-urunler'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/IceHaze-Cam-Suyu-Antifrizi.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6105,
    name: 'T-RaX Ayna Asmalı 8 ML - Sun Cream Dream',
    description: 'T-RaX Ayna Asmalı 8 ML - Sun Cream Dream',
    salePrice: 135,
    regularPrice: 215,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Asma-Parfum-Coconut.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6176,
    name: 'T-RaX Limon Kolonyası Sprey 50ML',
    description: 'T-RaX Limon Kolonyası Sprey 50ML',
    salePrice: 39,
    regularPrice: 55,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Limon-Kolonyasi-50ML.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6178,
    name: 'T-RaX Limon Kolonyası Sprey 200ML',
    description: 'T-RaX Limon Kolonyası Sprey 200ML',
    salePrice: 0,
    regularPrice: 99.98,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Limon-Kolonyasi-Orta.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6180,
    name: 'T-RaX Sihirli Sünger',
    description: 'T-RaX Sihirli Sünger',
    salePrice: 89.99,
    regularPrice: 120,
    categories: ['aksesuar-temizlik'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Sihirli-Silgi-Sungeri.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6182,
    name: 'T-RaX Renkli Cila - Siyah - 250ML',
    description: 'T-RaX Renkli Cila - Siyah - 250ML',
    salePrice: 159.5,
    regularPrice: 198.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-21_24_45.png'],
    stock: 99997,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6184,
    name: 'T-RaX Renkli Cila – Kırmızı – 250ML',
    description: 'T-RaX Renkli Cila – Kırmızı – 250ML',
    salePrice: 159.5,
    regularPrice: 198.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-21_18_50.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6186,
    name: 'T-RaX Renkli Cila – Gri – 250ML',
    description: 'T-RaX Renkli Cila – Gri – 250ML',
    salePrice: 159.5,
    regularPrice: 198.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-21_21_08.png'],
    stock: 99999,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6189,
    name: 'T-RaX Cam Çek Çek',
    description: 'T-RaX Cam Çek Çek',
    salePrice: 0,
    regularPrice: 0,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/cam_A§ek_A§ek-removebg-preview.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6192,
    name: 'T-RaX Yazlık Cam Suyu - 5LT',
    description: 'T-RaX Yazlık Cam Suyu - 5LT',
    salePrice: 0,
    regularPrice: 0,
    categories: ['aksesuar-temizlik', 'cam-suyu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Cam-Suyu-Antifrizi-5LT.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6194,
    name: 'T-RaX Fırçasız Oto Köpük 20LT',
    description: 'T-RaX Fırçasız Oto Köpük 20LT',
    salePrice: 1225,
    regularPrice: 1400,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/x23x3.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6552,
    name: 'T-RaX Exclusive Kova Set',
    description: 'T-RaX Exclusive Kova Set',
    salePrice: 1225,
    regularPrice: 1475,
    categories: ['aksesuar-temizlik', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/Adsiz-tasarim-1.png'],
    stock: 12,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6555,
    name: 'T-Rax Eco Kova Set',
    description: 'T-Rax Eco Kova Set',
    salePrice: 975,
    regularPrice: 1000,
    categories: ['aksesuar-temizlik', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ECOHET.png'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 6818,
    name: 'Lastik Tamir Kiti 400 Ml',
    description: 'Lastik Tamir Kiti 400 Ml',
    salePrice: 278.5,
    regularPrice: 350.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.06-4.jpeg'],
    stock: 99996,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7123,
    name: 'T-RAX SİLİKONLU CAM TEMİZLEYİCİ 750 ML',
    description: 'T-RAX SİLİKONLU CAM TEMİZLEYİCİ 750 ML',
    salePrice: 168.5,
    regularPrice: 275.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-19_30_31.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7198,
    name: 'T-RAX KLİMA BOMBASI 150ML NARCOSE',
    description: 'T-RAX KLİMA BOMBASI 150ML NARCOSE',
    salePrice: 0,
    regularPrice: 200,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.06-5.jpeg'],
    stock: 99994,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7204,
    name: 'T-RAX GÜDERİ BEZ 50 X 60',
    description: 'T-RAX GÜDERİ BEZ 50 X 60',
    salePrice: 300,
    regularPrice: 499.5,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-21_10_08.png'],
    stock: 100000,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7208,
    name: 'T-RAX SUSUZ MOTOR TEMİZLEYİCİ 500 ML',
    description: 'T-RAX SUSUZ MOTOR TEMİZLEYİCİ 500 ML',
    salePrice: 288.5,
    regularPrice: 428.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.05-4.jpeg'],
    stock: 99995,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7209,
    name: 'T-RAX SERAMİK LASTİK PARLATICI 500 ML',
    description: 'T-RAX SERAMİK LASTİK PARLATICI 500 ML',
    salePrice: 288.5,
    regularPrice: 428.5,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-19_30_54.png'],
    stock: 99963,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7665,
    name: 'T-RaX Oto Cilalı Şampuan ELMA Kokulu 1LT',
    description: 'T-RaX Oto Cilalı Şampuan ELMA Kokulu 1LT',
    salePrice: 199,
    regularPrice: 225,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-04-26-at-10.53.06-7.jpeg'],
    stock: 99998,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7684,
    name: 'T-RAX PREMIUM KAĞIT KOKU -  1-  HOURGLASS',
    description: 'T-RAX PREMIUM KAĞIT KOKU -  1-  HOURGLASS',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-11-Photoroom.png'],
    stock: 5,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7705,
    name: 'T-RAX PREMIUM KAĞIT KOKU -  3- KATTEGAT VANILLA PRIDE',
    description: 'T-RAX PREMIUM KAĞIT KOKU -  3- KATTEGAT VANILLA PRIDE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-3-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7707,
    name: 'T-RAX PREMIUM KAĞIT KOKU -  4-KATTEGAT MILLION',
    description: 'T-RAX PREMIUM KAĞIT KOKU -  4-KATTEGAT MILLION',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-4-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7709,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 5-PEACE',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 5-PEACE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-5-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7711,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 6-SPECİAL MILLION',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 6-SPECİAL MILLION',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-6-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7713,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 7-SPIRITUEL',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 7-SPIRITUEL',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-7-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7716,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 8-TORNEO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 8-TORNEO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-8-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7718,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 9-TORNEO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 9-TORNEO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-9-Photoroom-1.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7722,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 10-AY YILDIZ VANILLA PRIDE',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 10-AY YILDIZ VANILLA PRIDE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-10-Photoroom.png'],
    stock: 9,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7723,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 11-CHERRY TREES',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 11-CHERRY TREES',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-11-Photoroom-1.png'],
    stock: 9,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7725,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 12-LONG NIGHT',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 12-LONG NIGHT',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-12-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7727,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 13-MOSKOVA',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 13-MOSKOVA',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-13-Photoroom-1-1.png'],
    stock: 6,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7732,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 14-RIO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 14-RIO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-14-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7734,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 15-SUNSET',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 15-SUNSET',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT15-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7736,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 17-AMSTERDAM',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 17-AMSTERDAM',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/17-1.jpg'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7738,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 18-DORTMUND',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 18-DORTMUND',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/18.jpg'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7740,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 19-LIZBON',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 19-LIZBON',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-19-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7742,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 20-BOGOTA',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 20-BOGOTA',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/20.jpg'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7744,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 21-FAVELA',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 21-FAVELA',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/21-1.jpg'],
    stock: 96,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7746,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 22-HANDSOME MAN',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 22-HANDSOME MAN',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-22-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7748,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 23-VALHALLA MILLION',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 23-VALHALLA MILLION',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-23-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7750,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 24-LONG NIHGT BACO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 24-LONG NIHGT BACO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-24-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7752,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 25-LONG NIGHT',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 25-LONG NIGHT',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-25-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7754,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 26-CHERRY TREES',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 26-CHERRY TREES',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-26-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7756,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 27-TORNEO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 27-TORNEO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-27-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7758,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 28-HONEY',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 28-HONEY',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-28-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7760,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 29-VALHALLA VANILLA PRIDE',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 29-VALHALLA VANILLA PRIDE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT-29-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7762,
    name: 'T-RAX PREMIUM KAĞIT KOKU -31-GENTLEMAN',
    description: 'T-RAX PREMIUM KAĞIT KOKU -31-GENTLEMAN',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT31-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7764,
    name: 'T-RAX PREMIUM KAĞIT KOKU -32-CHERRY TREES',
    description: 'T-RAX PREMIUM KAĞIT KOKU -32-CHERRY TREES',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT32-Photoroom-1.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7766,
    name: 'T-RAX PREMIUM KAĞIT KOKU -34-İSTANBUL',
    description: 'T-RAX PREMIUM KAĞIT KOKU -34-İSTANBUL',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT34-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7768,
    name: 'T-RAX PREMIUM KAĞIT KOKU -35-FREE FIELD',
    description: 'T-RAX PREMIUM KAĞIT KOKU -35-FREE FIELD',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT35-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7771,
    name: 'T-RAX PREMIUM KAĞIT KOKU -36-SUNSET',
    description: 'T-RAX PREMIUM KAĞIT KOKU -36-SUNSET',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT36-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7773,
    name: 'T-RAX PREMIUM KAĞIT KOKU -37-PLAZZO',
    description: 'T-RAX PREMIUM KAĞIT KOKU -37-PLAZZO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT37-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7775,
    name: 'T-RAX PREMIUM KAĞIT KOKU -38-TARGET POINT',
    description: 'T-RAX PREMIUM KAĞIT KOKU -38-TARGET POINT',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT38-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7777,
    name: 'T-RAX PREMIUM KAĞIT KOKU -39-SUNSET',
    description: 'T-RAX PREMIUM KAĞIT KOKU -39-SUNSET',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT39-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7779,
    name: 'T-RAX PREMIUM KAĞIT KOKU -40-FREE FIELD',
    description: 'T-RAX PREMIUM KAĞIT KOKU -40-FREE FIELD',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT40-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7781,
    name: 'T-RAX PREMIUM KAĞIT KOKU -41-BACO',
    description: 'T-RAX PREMIUM KAĞIT KOKU -41-BACO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT41-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7783,
    name: 'T-RAX PREMIUM KAĞIT KOKU -42-VALHALLA',
    description: 'T-RAX PREMIUM KAĞIT KOKU -42-VALHALLA',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT42-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7785,
    name: 'T-RAX PREMIUM KAĞIT KOKU -43-SUNSHINE',
    description: 'T-RAX PREMIUM KAĞIT KOKU -43-SUNSHINE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT43-Photoroom-1.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7788,
    name: 'T-RAX PREMIUM KAĞIT KOKU -44-SUNSHINE',
    description: 'T-RAX PREMIUM KAĞIT KOKU -44-SUNSHINE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT44-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7789,
    name: 'T-RAX PREMIUM KAĞIT KOKU -45-FREE FIELD',
    description: 'T-RAX PREMIUM KAĞIT KOKU -45-FREE FIELD',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT45-Photoroom.png'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7792,
    name: 'T-RAX PREMIUM KAĞIT KOKU -46- AY YILDIZ VANILLA PRIDE',
    description: 'T-RAX PREMIUM KAĞIT KOKU -46- AY YILDIZ VANILLA PRIDE',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/KAGIT46-Photoroom.png'],
    stock: 6,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7825,
    name: 'T-RaX Saf Su Ve Ütü Suyu 1 Litre',
    description: 'T-RaX Saf Su Ve Ütü Suyu 1 Litre',
    salePrice: 0,
    regularPrice: 0,
    categories: ['aksesuar-temizlik', 'oto-bakim'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-20_28_09.png'],
    stock: 99980,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7861,
    name: 'T-RAX  SERAMİK LASTİK PARLATICI 500 ML  – 5’li Set',
    description: 'T-RAX  SERAMİK LASTİK PARLATICI 500 ML  – 5’li Set',
    salePrice: 0,
    regularPrice: 1092.5,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-17-May-2026-16_25_27.png'],
    stock: 99960,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7864,
    name: 'T-RAX  SERAMİK LASTİK PARLATICI 500 ML  – 2’li Set',
    description: 'T-RAX  SERAMİK LASTİK PARLATICI 500 ML  – 2’li Set',
    salePrice: 528,
    regularPrice: 577,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-20_49_06.png'],
    stock: 99961,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 7979,
    name: 'TRAX Premium Oto Bakım Seti – Komple Temizlik & Koruma Paketi',
    description: 'TRAX Premium Oto Bakım Seti – Komple Temizlik & Koruma Paketi',
    salePrice: 0,
    regularPrice: 1400,
    categories: ['aksesuar-temizlik', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-19_29_09.png'],
    stock: 12,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8031,
    name: 'Trax Premium Kaliteli Oto Araç Kokusu 8\'li',
    description: 'Trax Premium Kaliteli Oto Araç Kokusu 8\'li',
    salePrice: 0,
    regularPrice: 470,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/8LI-SETT.webp'],
    stock: 10,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8043,
    name: 'T-RaX Narcose Koku Bombası Araç içi ve Klima Dezenfektan Temizleyici Sprey 150ML 5’li set',
    description: 'T-RaX Narcose Koku Bombası Araç içi ve Klima Dezenfektan Temizleyici Sprey 150ML 5’li set',
    salePrice: 0,
    regularPrice: 610,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-20_41_09.png'],
    stock: 99994,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8045,
    name: 'T-RaX Special Million Kokulu Bombası Araç içi ve Klima Dezenfektan Temizleyici Sprey 150ML 5’li set',
    description: 'T-RaX Special Million Kokulu Bombası Araç içi ve Klima Dezenfektan Temizleyici Sprey 150ML 5’li set',
    salePrice: 0,
    regularPrice: 610,
    categories: ['oto-bakim', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ChatGPT-Image-7-May-2026-20_34_43.png'],
    stock: 99994,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8068,
    name: 'T-RAX Konsantre Torpido Bakım Sütü 5 LT',
    description: 'T-RAX Konsantre Torpido Bakım Sütü 5 LT',
    salePrice: 0,
    regularPrice: 755,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/67BAB064-F6D8-4078-B778-AF7CFB0FF869.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8070,
    name: 'T-RaX Konsantre Lastik ve Tampon Parlatıcı 5 LT',
    description: 'T-RaX Konsantre Lastik ve Tampon Parlatıcı 5 LT',
    salePrice: 0,
    regularPrice: 755,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/AF3BEB40-212A-434F-B5F4-0E0CEA79974D.png'],
    stock: 1,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8566,
    name: 'T-RAX Torpido Bakım Sütü 500 ML Torpido Parlatıcı, Göğüs Parlatıcı',
    description: 'T-RAX Torpido Bakım Sütü 500 ML Torpido Parlatıcı, Göğüs Parlatıcı',
    salePrice: 0,
    regularPrice: 288.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/ORNEK.png'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8573,
    name: 'T-RAX PREMIUM KAĞIT KOKU - 62 LONG NIGHT BACO',
    description: 'T-RAX PREMIUM KAĞIT KOKU - 62 LONG NIGHT BACO',
    salePrice: 89,
    regularPrice: 129,
    categories: ['arac-oda-parfumu'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/FB94B444-B674-4CEE-BD42-6139B83E24DF.png'],
    stock: 100,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: true,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8581,
    name: 'T-RaX Klima Bombası Rock House 150ML',
    description: 'T-RaX Klima Bombası Rock House 150ML',
    salePrice: 0,
    regularPrice: 200,
    categories: ['aksesuar-temizlik', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-05-04-at-21.58.58.jpeg'],
    stock: 99995,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8583,
    name: 'T-RAX Oto Hızlı Cila 500 ML Araç Boya Koruma ve Parlatıcı',
    description: 'T-RAX Oto Hızlı Cila 500 ML Araç Boya Koruma ve Parlatıcı',
    salePrice: 0,
    regularPrice: 288.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/WhatsApp-Image-2026-05-04-at-22.00.58.jpeg'],
    stock: 3,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
  {
    id: 8598,
    name: 'T-RAX TRX-47 Pas Sökücü & Yağ Çözücü Sprey 200 ml',
    description: 'T-RAX TRX-47 Pas Sökücü & Yağ Çözücü Sprey 200 ml',
    salePrice: 0,
    regularPrice: 273.5,
    categories: ['aksesuar-temizlik', 'oto-bakim', 'professional', 'aerosol'],
    images: ['https://traxcarcareproducts.com/wp-content/uploads/TRX47.jpg'],
    stock: 100,
    inStock: true,
    rating: 0,
    reviewCount: 0,
    isCampaign: false,
    isNew: false,
    isFeatured: false,
    brand: 'T-RaX',
  },
];

export function getProductsByCategory(categorySlug: string): Product[] {
  return products.filter(p => p.categories.includes(categorySlug));
}

export function getCampaignProducts(): Product[] {
  return products.filter(p => p.isCampaign && p.inStock);
}

export function getNewProducts(): Product[] {
  return products.filter(p => p.isNew && p.inStock);
}

export function getFeaturedProducts(): Product[] {
  return products.filter(p => p.isFeatured && p.inStock);
}

export function searchProducts(query: string): Product[] {
  const q = query.toLowerCase();
  return products.filter(p =>
    p.name.toLowerCase().includes(q) ||
    p.description.toLowerCase().includes(q) ||
    p.categories.some(c => c.toLowerCase().includes(q))
  );
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);
}
